import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';
import { ProfileService } from '../services/profile.service';
import { environment } from '../../../environments/environment';
import { UtilityService } from '../services/utility.service';
import { ProfileSetting } from '../../pages/profile/profile.component';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-utility-navigation',
    templateUrl: './utility-navigation.component.html',
    styleUrls: ['./utility-navigation.component.scss'],
    standalone: false
})
export class UtilityNavigationComponent  {
    @Output() asideStatus = new EventEmitter<boolean>();

    constructor(
        public profileService: ProfileService,
        public auth: AuthenticationService,
        public utility: UtilityService,
        private router: Router
    ) { }

    toggle() {
        this.asideStatus.emit();
    }
        
    public get isEditor(): boolean {
        return this.auth.token && this.auth.token.isFound && this.auth.token.payload["Kfbs.Content.Modify"]; 
    }
    public get isInspector(): boolean {
        return this.auth.token && this.auth.token.isFound && this.auth.token.payload["Kfbs.Environment.View"];
    }
    public toggleInspector(): void {
        environment.showDebug = !environment.showDebug;
    }

    public selectVersion(profile) {
        var data: ProfileSetting[] = [new ProfileSetting()]
        profile.version = profile.version == 1 ? 2 : 1;

        data[0].Id = ".Myke.Version";
        data[0].Type = "byte";
        data[0].Value = profile.version.toString();

        var redirect = false;

        // we need to check if the user is audienced for this page before switching.       
        var pagename = this.router.url.replace("/", "");
        var page = pagename.charAt(0).toUpperCase() + pagename.slice(1); //convert to titlecase
        //ignore dashboard and profile       
        if (page != 'Dashboard' && page != 'Profile') {
            if (profile.version < 2)
                redirect = !this.profileService.pageStore[page];
            else
                redirect = !this.profileService.componentStore[page];
        }       
       
        switch (this.router.url) {
            case '/':
            case '/catalog':
            case '/dashboard':
            case '/people':
            case '/profile':
                break;
            default:
                redirect = true;
        }

        this.profileService.updateSettings(data, true, redirect);
    }
}
